export default "__VITE_ASSET__DDYS0itu__"